'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
function $f_Lpresto_crud$PageView__execute__O__Lcom_raquo_airstream_core_EventStream($thiz, req) {
  return ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_EventStream$()).sZ;
}
export { $f_Lpresto_crud$PageView__execute__O__Lcom_raquo_airstream_core_EventStream as $f_Lpresto_crud$PageView__execute__O__Lcom_raquo_airstream_core_EventStream };
//# sourceMappingURL=presto.crud$-Page-View.js.map
